// extracted by mini-css-extract-plugin
export default {"userMenuToggle":"UserMenu_userMenuToggle__8n6YD","userMenu":"UserMenu_userMenu__hNBhP"};